<div [formGroup]="configFormGroup">
  <h2>Google Map Config</h2>
  <div dwRow>
    <div dwCol="6">
      <label>Latitude Attribute</label>
      <select formControlName="latitudeAttr" class="form-control">
        <option *ngFor="let attr of itemMetaData?.Attributes" [ngValue]="attr.AttributeName">
          {{ attr.Display }}
        </option>
      </select>
    </div>
  </div>
  <div dwRow>
    <div dwCol="6">
      <label>Longitude Attribute</label>
      <select formControlName="longitudeAttr" class="form-control">
        <option *ngFor="let attr of itemMetaData?.Attributes" [ngValue]="attr.AttributeName">
          {{ attr.Display }}
        </option>
      </select>
    </div>
  </div>
  <div dwRow>
    <div dwCol="6">
      <label>Color</label>
      <select formControlName="color" class="form-control">
        <option value="red">Red</option>
        <option value="green">Green</option>
      </select>
    </div>
  </div>
  <div dwRow>
    <div dwCol="6">
      <label>Display Template</label>
      <input type="text" formControlName="displayTemplate" class="form-control">
    </div>
  </div>
</div>